import {
    ROUTER_GO,
    ROUTER_GO_BACK,
    ROUTER_NAVIGATION_CANCEL,
    ROUTER_NAVIGATION_SUCCESS,
    ROUTER_REDIRECT_TO_URL,
    ROUTER_STATE_SET,
    ROUTER_TO_CHILD_NAVIGATION
} from './../action-types';
import { Action } from '@ngrx/store';
import { IAppRouterState } from '../router/router-state';

export class RouterGoAction implements Action {
public readonly type = ROUTER_GO;

constructor(public payload: {
    name?: string,
    url?: string,
    path?: string,
    params?: any,
    options?: any
}) {}
}

export class RouterGoBackAction implements Action {
    readonly type = ROUTER_GO_BACK;
}

export class RouterRedirectToUrlAction implements Action {
    readonly type = ROUTER_REDIRECT_TO_URL;

    constructor(
        public payload: {
            url: string;
        }
    ) {}
}

export class RouterNavigationSuccessAction implements Action {
    readonly type = ROUTER_NAVIGATION_SUCCESS;
}

export class RouterNavigationCancelAction implements Action {
    readonly type = ROUTER_NAVIGATION_CANCEL;

    constructor(public payload: { state: string; options?: any }) {}
}

export class SetRouterStateAction implements Action {
    public readonly type = ROUTER_STATE_SET;

    constructor(public payload: {
        routerState: IAppRouterState
    }) {}
}

export class RouterToChildNavigation implements Action {
    readonly type = ROUTER_TO_CHILD_NAVIGATION;

    constructor(
        public payload: {
            routerState: IAppRouterState;
        }
    ) {}
}